// Shared by Footer and CompactFooter so the two cannot drift apart.
export const PRIVACY_POLICY_URL = 'https://frontiertech.edu/privacy-policy/';
export const TERMS_OF_USE_URL = 'https://frontiertech.edu/terms-of-use/';
export const PHONE = { label: '+1 (307) 264-2843', href: 'tel:+13072642843' };
export const ADDRESS_LINES = ['140 E Broadway Ave, #25', 'Jackson, WY 83001'];
